/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
/* eslint-disable no-debugger */
/* eslint-disable max-statements */
import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroller";
import { useHistory } from "react-router";
import loadable from "@loadable/component";

import InventoryCarCardRevamp from "../inventory-car-card-revamp";
import Skeleton from "../inventory-car-card/skeleton";
import { CAR_LIST_EVENT_NAMES, FILTER_ENTITIES, NUMBER, PAGE_SOURCE } from "../../../constants/app-constants";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import Filters from "../../../utils/filters-v2";
import qs from "querystring";
import styles from "./styles.css";
import { useInView } from "react-intersection-observer";
import ScrollButton from "../../shared/scroll-button";
import NoCarFoundRevamp from "../no-car-found-revamp";
import { SOURCE } from "../inventory-car-card/constant";
import withWishlist from "../with-wishlist";
import withLogin from "../with-login";
import { trackCustomReMarketingEvents, trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import ListingFilterSeoRevamp from "../listing-filter-seo-revamp";

import { MARKETING_EVENTS_CONSTANTS } from "../../../tracking/marketing-page-events";
import GetPreApproveNewCardInSecondsRevamp from "../get-pre-approve-new-card-in-seconds-revamp";
import { getCity } from "../../../utils/helpers/get-city-from-listing";
import { BOOL_STATE } from "../../../constants/checkout-constants";
import TrackImpression from "../../shared/track-impression";
import { AMPLITUDE_EVENTS_CATEGORY } from "../../../tracking/amplitude-events";
import BuyCarBreadCrumb from "../buy-car-breadcrumb";
import ErrorHandler from "../../shared/with-error-handler";
import SortBy from "../sort-by";
import ArrowIcon from "../../shared/arrow";
import FilterRevamp from "../filter-revamp";
import SearchRevamp from "../search-revamp";

import SpecificCarDescription from "../../shared/specific-car-description";
import { INLINE_FILTER_TITLES } from "../../../utils/filters-v2/constants";
import FinanceCarLoanEligibiltyClpBanner from "../finance-car-loan-eligibilty-clp-banner";
import PreApprovedClpBannerVariantB from "../pre-approved-clp-banner-b";
import TestDriveNudge from "../test-drive-v2/components/test-drive-nudge";
import { getAbExpirementVariant, isExperimentNull } from "../../../utils/helpers/get-ab-expirement-variant";
import getCookie from "../../../utils/helpers/get-cookie";
import TradeInOrSellCarClpBanner from "../trade-in-or-sell-car-clp-banner";
import { AMPLITUDE_EXPERIMENT_NAME, GA_EXPERIMENT_NAME } from "./tracking";
import isTestDriveEnabledState from "../../../utils/helpers/is-test-drive-enabled-state";
import useQueryParams from "../../../hooks/use-queryPrams";
import { CLP_CRM_VARIANTS, getCurrentCrmVariant, getIsCrmVariant } from "./helper";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import ClpPriceDropBanner from "../clp-price-drop-banner";
import ClpNewArrivalBanner from "../clp-new-arrival-banner";
import useModifiedFilters from "../../../hooks/use-modified-filters";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import HappyBuyerReviewCard from "../happy-buyer-review-card/component";
import Google from "./images/google.svg";
import TrustPilot from "./images/trustpilot.svg";
import Product from "./images/product-review.svg";
import { CDP_REVIEW_LINK } from "../../../constants/app-constants";

const SimilarCars = loadable(() => import("../similar-cars-clp"));
const OurLocationModal = loadable(() => import("../our-location-modal"));
const HappyPurchase = loadable(() => import("../happy-purchase/component"));
const ExtendedWarrantyCardRevamp = loadable(() => import("../extended-warranty-card-revamp/component"));
const PreApprovedClpBannerRevamp = loadable(() => import("../pre-approved-clp-banner-revamp/component"));
const BuyWithConfidenceRevamp = loadable(() => import("../buy-with-confidence-revamp"));

const SEO_FILTER_CAR_LIST = {
    [NUMBER.FIVE]: {
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    },
    [NUMBER.FIFTEEN]: {
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    },
    [NUMBER.TWENTY_ONE]: {
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    },
    [NUMBER.TWENTY_SEVEN]: {
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    },
    [NUMBER.THIRTY_THREE]: {
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    },
    [NUMBER.THIRTY_NINE]: {
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    },
    [NUMBER.FOURTY_FIVE]: {
        filterName: FILTER_ENTITIES.FUEL_TYPE,
        itemVisible: 6,
        component: ListingFilterSeoRevamp
    }
};

const CarListRevamp = ({
    content = [],
    totalCars,
    page,
    isLoading,
    fetchCarListConnect,
    config,
    allFilters,
    location,
    isSSR,
    updateSSRStatusConnect,
    urlOptions,
    selectedFilters = [],
    shouldReloadList,
    reloadCarListConnect,
    resetCarListConnect,
    isLoggedIn,
    secureToken,
    fetchWishlistedCarsListConnect,
    getInhouseEligibilityConnect,
    loanType,
    preApproved,
    ipDetectedState = "",
    userTradeInData,
    tradeInToggleSelected,
    getPreApprovalLoanDetailsConnect,
    setMarketingCategoryConnect,
    selectedOnScreenFilter,
    updateSelectedOnScreenFilterConnect,
    fbEventType,
    metaContent = {},
    isSortModalOpen,
    updateAllFiltersVisibilityConnect,
    updateSortModalVisibilityConnect,
    selectedSort,
    dynamicContent,
    selectedCategory,
    categories,
    showFilterPageRevamp,
    similarCarsContent,
    totalSimilarCars,
    similarCarPage,
    totalSimilarPages,
    isSimilarCarLoading,
    fetchSimilarCarConnect,
    inlineFilters = [],
    buyWithConfidence = [],
    absolutePermissibleLoanAmount,
    maxPermissibleRepaymentPerWeek,
    stEligible = false,
    userGeoData,
    webPriceDropDesktop,
    galleryOnTheFlyDesktop,
    testDriveConfig,
    ratingAndReviews
}) => {

    const history = useHistory();
    const queryParams = parseLocationSearchParams(location.search);
    const infiniteScrollRef = useRef();

    const [hasMoreItems, setHasMoreItems] = useState(true);
    const [showViewLatestCars, setShowViewLatestCars] = useState(
        parseInt(queryParams.page) > NUMBER.ONE
    );
    const [showLocationModal, setShowLocationModal] = useState(false);

    const [viewLatestRef, inView, entry] = useInView({
        threshold: 0
    });
    const { tradeIn = false } = userTradeInData || {};
    const pathname = location.pathname;
    const listingPath = pathname.slice(1);

    const queryString = qs.stringify(queryParams);

    const searchQuery = queryParams.search || "";
    const sort = queryParams.sort;
    const totalPages = Math.ceil(totalCars / NUMBER.TWENTY);
    const { isPurposeBusiness = BOOL_STATE.NO } = loanType || {};
    const isPersonal = isPurposeBusiness === BOOL_STATE.NO;
    const isSeoPath = !Object.keys(queryParams)?.length;
    const {state: { name: stateName } = ""} = userGeoData || {};
    const { eligibleStateNames = [] } = testDriveConfig?.data || {};
    const showTestDriveStrip = isTestDriveEnabledState({stateName, userState: stateName, eligibleStateNames});
    const {mainFilter: isCityNameFilterAllowed = false} = allFilters?.[FILTER_ENTITIES.CITYNAME] || {};

    const queryParmas = useQueryParams();
    const isClpCrmVariant = getIsCrmVariant(queryParmas);
    const showWebPriceDesktop =
        getAbExpirementVariant(webPriceDropDesktop, EXPERIMENT_TYPE.VARIANT_B) && isClpCrmVariant;
    const crmVariant = getCurrentCrmVariant(queryParmas);
    const {getModifiedFilters} = useModifiedFilters(isCityNameFilterAllowed);
    useEffect(() => {
        trackDesktopCustomEventsAU(GA_EXPERIMENT_NAME.GALLERY_ON_THE_FLY_DESKTOP, {
            ...GA_EXPERIMENT_NAME.GALLERY_ON_THE_FLY_DESKTOP,
            eventLabel: galleryOnTheFlyDesktop?.data
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchListing = (nextPage) => {
        const { code } = getCity(metaContent);
        const filtes = new Filters({ cityCode: code });

        const modifiedFilter = getModifiedFilters(selectedFilters);

        const { payload } = filtes.getListingPayload({
            selectedFilters: modifiedFilter,
            filters: allFilters,
            options: {
                ...urlOptions,
                page: nextPage || 0,
                ...(
                    searchQuery && {
                        search: searchQuery,
                        searchVariant: true
                    }
                ),
                ...(
                    sort && {
                        sort
                    }
                ),
                ...(tradeInToggleSelected && ({ tradeIn: tradeInToggleSelected })),
                searchSimilarVariant: false
            }
        });
        fetchCarListConnect({
            size: 20,
            spath: listingPath,
            page: nextPage || 0
        }, payload).then((response) => {
            const { results = [] } = response || {};
            const filterResult = results.slice(0, NUMBER.FIVE);
            const topAppid = filterResult.map(item => item.appointmentId);
            const topAppIdSet = Array.from(new Set(selectedFilters.map(item => item.optionKey)));

            if (selectedOnScreenFilter === "make") {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CATEGORY, {
                    "ecomm_prodid": filterResult.map(item => item.appointmentId)
                });
                setMarketingCategoryConnect(false);
            } else if (searchQuery) {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.SEARCH_RESULTS, {
                    "ecomm_prodid": filterResult.map(item => item.appointmentId)
                });
                if (results.length === 0) {
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SEARCH_NO_RESULT_SCREEN, { eventLabel: searchQuery });
                }
            } else if (!nextPage) {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.VIEW_ALL_CARS, {
                    "ecomm_prodid": filterResult.map(item => item.appointmentId)
                });
            }
            if (fbEventType) {
                trackDesktopCustomEventsAU(fbEventType, {
                    eventLabel: `${topAppIdSet.join(",")}${searchQuery || ""}`,
                    appIds: topAppid
                });
            }
            updateSelectedOnScreenFilterConnect("");
            setHasMoreItems(true);
        });
    };

    const fetchSimilarCars = (nextPage = NUMBER.ZERO) => {
        const {code} = getCity(metaContent);
        const filtes = new Filters({ cityCode: code });

        const modifiedFilter = getModifiedFilters(selectedFilters);

        const { payload } = filtes.getListingPayload({
            selectedFilters: modifiedFilter,
            filters: allFilters,
            options: {
                ...urlOptions,
                page: nextPage || 0,
                ...(
                    searchQuery && {
                        search: searchQuery,
                        searchVariant: true
                    }
                ),
                ...(
                    sort && {
                        sort
                    }
                ),
                ...(tradeIn && ({ tradeIn: tradeInToggleSelected })),
                searchSimilarVariant: true
            }
        });
        fetchSimilarCarConnect(
            {
                size: 20,
                spath: listingPath,
                page: nextPage || 0
            },
            payload
        ).then((response) => {
            const {results = []} = response || {};
            const filterResult = results.slice(0, NUMBER.FIVE);
            const topAppid = filterResult.map(item => item.appointmentId);
            const topAppIdSet = Array.from(new Set(selectedFilters.map(item => item.optionKey)));
            if (selectedOnScreenFilter === "make") {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CATEGORY, {
                    "ecomm_prodid": topAppid
                });
            } else if (searchQuery) {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.SEARCH_RESULTS, {
                    "ecomm_prodid": topAppid
                });
                if (results.length === 0) {
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SEARCH_NO_RESULT_SCREEN, {eventLabel: searchQuery});
                }
            } else if (!nextPage) {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.VIEW_ALL_CARS, {
                    "ecomm_prodid": topAppid
                });
            }
            if (fbEventType) {
                trackDesktopCustomEventsAU(fbEventType, {
                    eventLabel: `${topAppIdSet.join(",")} ${searchQuery || ""}`,
                    appIds: topAppid
                });
            }
            updateSelectedOnScreenFilterConnect("");
            setHasMoreItems(true);
        });
    };

    const loadSimilarCars = () => {
        if ((similarCarPage + 1 < totalSimilarPages) && !isSimilarCarLoading || totalSimilarPages === null && !isSimilarCarLoading) {
            fetchSimilarCars(similarCarPage + 1);
        }
    };

    const loadMore = () => {
        setHasMoreItems(false);
        if ((page + 1 < totalPages) && !isLoading || totalPages === null && !isLoading) {
            fetchListing(page + 1);
        } else if (isSeoPath || (!isSeoPath && (searchQuery || selectedFilters.length > NUMBER.ZERO))) {
            loadSimilarCars();
        }
    };

    const onClickViewLatestCars = async() => {
        setHasMoreItems(true);
        await yieldToMain();
        window.scrollTo(0, 0);
        updateSSRStatusConnect(false);
        setShowViewLatestCars(false);
    };

    const shouldShowViewLatestCars = (index) => {
        if (index !== NUMBER.ONE ||
            content.length === NUMBER.ZERO ||
            page < NUMBER.TWO
        ) { return false; }
        return showViewLatestCars;
    };

    useEffect(() => {
        updateSSRStatusConnect(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryString]);

    useEffect(() => {
        if (isLoggedIn) {
            getInhouseEligibilityConnect();
            getPreApprovalLoanDetailsConnect({ fetchListingDetails: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if ((isLoggedIn && !shouldReloadList) || tradeInToggleSelected) {
            resetCarListConnect();
            fetchListing();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, tradeInToggleSelected]);

    useEffect(() => {
        reloadCarListConnect(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (ipDetectedState) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOCATION_STATE_LISTING, { eventLabel: ipDetectedState });
        }
    }, [ipDetectedState]);

    useEffect(() => {
        if (!isSSR && shouldReloadList) {
            resetCarListConnect();
            fetchListing();
        }
        reloadCarListConnect(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryString, shouldReloadList], isSSR);

    useEffect(() => {
        if (isLoggedIn && secureToken) {
            fetchWishlistedCarsListConnect(secureToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    // To update similarCar list to empty on searchQuery Change
    useEffect(() => {
        // eslint-disable-next-line no-magic-numbers
        if (totalCars <= 3 && isLoading === false && (similarCarsContent || []).length === 0) {
            loadMore();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, isLoading, totalCars]);

    useEffect(() => {
        const testDriveVariant = getCookie(AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE);
        let customStateVariant = getCookie(AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT);
        customStateVariant = isExperimentNull(customStateVariant) ? null : customStateVariant;

        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE, {
            eventAction: AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE,
            eventLabel: isExperimentNull(testDriveVariant) ? null : testDriveVariant,
            eventCategory: "Cars24_listing_page"
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT, {
            eventAction: AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT,
            eventLabel: `${customStateVariant}_${JSON.stringify(userGeoData)}`,
            eventCategory: "Cars24_listing_page"
        });

        trackDesktopCustomEventsAU(GA_EXPERIMENT_NAME.CAR_CARD_HOVER_VARIANT_ASSIGNED_DATA, {...GA_EXPERIMENT_NAME.CAR_CARD_HOVER_VARIANT_ASSIGNED_DATA, eventLabel: "VARIANT_B"});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onClickCallback = (car) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE_CARD_OPEN, {
            eventLabel: car.reserved ? "reserved" : "ready_for_sale"
        });
    };

    const handleFullDetails = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_COVER_WARRANTY, { eventLabel: "CLP_LM_Platinum_cover" });
        window.open("/cars24cover/", "_blank");
    };

    const renderSeoFilterComponent = (index) => {
        // personalised
        const { component: Component, title, filterName, itemVisible, showImage } = SEO_FILTER_CAR_LIST[index];
        const currentFilterType = (inlineFilters || []).filter(item => item.type === filterName);
        const suggestions = currentFilterType.length > 0 ? currentFilterType[0].suggestions || [] : [];
        return (
            suggestions?.length > 0 && <Component title={title} filterName={filterName} itemVisible={itemVisible} showFilterPageRevamp={showFilterPageRevamp} showImage={showImage} suggestions={suggestions} />
        );
    };
    Object.keys(SEO_FILTER_CAR_LIST).map((key, index) => {
        if (inlineFilters[index]) {
            const filterType = inlineFilters[index].type;
            SEO_FILTER_CAR_LIST[key].filterName = filterType;
            SEO_FILTER_CAR_LIST[key].title = INLINE_FILTER_TITLES[filterType];
            if (filterType === FILTER_ENTITIES.MAKE) {
                SEO_FILTER_CAR_LIST[key].showImage = true;
            } else {
                SEO_FILTER_CAR_LIST[key].showImage = false;
            }
        }
    });
    const renderSimilarCarComponent = () => {
        return (
            <TrackImpression event={{ amplitudeName: AMPLITUDE_EVENTS_CATEGORY.SIMILAR_CARS_SEEN }} wrapWithDiv={false}>
                <SimilarCars similarCarsContent={similarCarsContent} config={config} />
            </TrackImpression>

        );
    };
    const {google, trustPilot, productReview} = ratingAndReviews || {};
    const onToggleSort = async () => {
        await yieldToMain();
        const eventType = !isSortModalOpen ? "FILTERS_MORE_SORT_TAB_OPEN" : "FILTERS_CLOSE";
        const eventLabel = !isSortModalOpen ? "NA" : "options More";
        updateSelectedOnScreenFilterConnect("");
        updateAllFiltersVisibilityConnect(false);
        updateSortModalVisibilityConnect(!isSortModalOpen);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS[eventType], { eventLabel });
    };

    const handleViewCars = () => {
        history.replace("/buy-used-cars-australia/");
        window.location.reload();
    };

    const handleShowLocationCallback = () => {
        setShowLocationModal(!showLocationModal);
    };

    return (
        <React.Fragment>
            {(!inView && entry && showViewLatestCars && !isLoading && page > 1) &&
                <ScrollButton text={"View Latest Cars"} onClick={onClickViewLatestCars} />
            }
            <div styleName={"styles.greyBg"}>
                <div styleName={"styles.testDriveNudgeWrapper"}>
                    <TestDriveNudge location={PAGE_SOURCE.CLP} showTestDriveVariant={showTestDriveStrip} />
                </div>
                <div className={"container"}>
                    <div styleName={"styles.listingWrap"}>
                        <div styleName={"styles.leftContainer"}>
                            <div styleName={"styles.leftFilterSectionWrapper"}>
                                <FilterRevamp />
                            </div>
                        </div>
                        <div styleName={"styles.rigtPanelWrapper"}>
                            <InfiniteScroll
                                ref={infiniteScrollRef}
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMoreItems}
                                initialLoad={false}
                            >
                                <div className={"row"}>
                                    <div className="col-12">
                                        <ErrorHandler>
                                            <BuyCarBreadCrumb />
                                        </ErrorHandler>

                                    </div>
                                    <SearchRevamp />

                                    {showWebPriceDesktop ? (
                                        <div styleName={"styles.priceDropWrapper"}>
                                            {crmVariant === CLP_CRM_VARIANTS.PRICE_DROP ? (
                                                <ClpPriceDropBanner />
                                            ) : (
                                                <ClpNewArrivalBanner />
                                            )}
                                        </div>
                                    ) : null}

                                    <div styleName="styles.headingSortByContainer" className="col-12">
                                        {(isLoading) ? null
                                            :
                                            <React.Fragment>
                                                {isLoading ? <p styleName={"styles.usedCarHeading"} /> : <div>
                                                    <SpecificCarDescription
                                                        dynamicContent={dynamicContent}
                                                        selectedCategory={selectedCategory}
                                                        categories={categories}
                                                        showHeader={true}
                                                        crmVariant={showWebPriceDesktop}
                                                    />
                                                </div>
                                                }
                                            </React.Fragment>
                                        }
                                        <div styleName="styles.sortContainer">
                                            <div styleName={"styles.recentlyAdd"}>
                                                <span styleName={"styles.label"}>Sort By:</span>
                                                <div styleName={"styles.recentlyDropdown"}>
                                                    <a onClick={onToggleSort} className="filter-section" styleName={"styles.recentlyItem"}>{selectedSort.displayText} <ArrowIcon rotateBy={90} /> </a>
                                                    {isSortModalOpen && <SortBy onToggleSort={onToggleSort} showFilterPageRevamp={showFilterPageRevamp} />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(content || []).map((item, index) => (

                                        <React.Fragment key={index}>
                                            {index === NUMBER.FOUR &&
                                                <div className={"col-md-4"}>
                                                    {preApproved && isPersonal ?
                                                        <TrackImpression event={{ amplitudeName: AMPLITUDE_EVENTS_CATEGORY.NEW_PRE_APPROVAL_TILE_SEEN, properties: { "Seen status": "Yes" } }}>
                                                            {stEligible ? <PreApprovedClpBannerRevamp absolutePermissibleLoanAmount={absolutePermissibleLoanAmount} maxPermissibleRepaymentPerWeek={maxPermissibleRepaymentPerWeek} /> : <PreApprovedClpBannerVariantB />}
                                                        </TrackImpression>
                                                        :
                                                        preApproved && isPurposeBusiness ?
                                                            <GetPreApproveNewCardInSecondsRevamp personalised={preApproved} isLoggedIn={isLoggedIn} /> :
                                                            <FinanceCarLoanEligibiltyClpBanner personalised={preApproved} />

                                                    }
                                                </div>
                                            }

                                            {index === NUMBER.EIGHT &&
                                                <div className={"col-md-4"}>
                                                    <ExtendedWarrantyCardRevamp onClick={handleFullDetails} />
                                                </div>
                                            }
                                            {SEO_FILTER_CAR_LIST[index] && renderSeoFilterComponent(index)}
                                            {index === NUMBER.SIX &&
                                                <div className={"col-md-4"}>
                                                    <TrackImpression event={{ gaName: GA_EXPERIMENT_NAME.CARD_VIEWED, data: { eventLabel: GA_EXPERIMENT_NAME.CARD_VIEWED, eventAction: "trade_in_card", eventCategory: "C2B" }, amplitudeName: AMPLITUDE_EXPERIMENT_NAME.TRADE_IN_CLP_REGO_CARD_VIEWED }}>
                                                        {/* <TradeinBannerListingRevamp/> */}
                                                        <TradeInOrSellCarClpBanner />
                                                    </TrackImpression>
                                                </div>
                                            }
                                            {
                                                index === NUMBER.SEVEN && <TrackImpression event={{ amplitudeName: AMPLITUDE_EVENTS_CATEGORY.VALUE_PROPS_SEEN }} wrapWithDiv={false}>
                                                    <BuyWithConfidenceRevamp source={PAGE_SOURCE.CLP.toUpperCase()} showHeader={true} buyWithConfidence={buyWithConfidence || []} config={config} />
                                                </TrackImpression>
                                            }
                                            <div key={index} className={"col-md-4"}>
                                                <InventoryCarCardRevamp
                                                    cardRef={
                                                        shouldShowViewLatestCars(index) ?
                                                            viewLatestRef : undefined
                                                    }
                                                    preload={index === 0}
                                                    index={index}
                                                    item={item}
                                                    bodyType={item.body || item.bodyType}
                                                    config={config}
                                                    source={SOURCE.LISTING}
                                                    egcRenderType="listing"
                                                    impressionSource={CAR_LIST_EVENT_NAMES.LISTING}
                                                    ampImpressionSource={CAR_LIST_EVENT_NAMES.LISTING_PAGE}
                                                    onClickCallback={() => onClickCallback(item)}
                                                    showLocationCallback={handleShowLocationCallback}
                                                    ampPageSource={PAGE_SOURCE.CLP}
                                                    {...({
                                                        ...item
                                                    })}
                                                />
                                            </div>
                                        </React.Fragment>

                                    ))
                                    }
                                    { totalSimilarCars > 0 && !isSimilarCarLoading && (
                                        <React.Fragment><hr styleName={"styles.border"} />{renderSimilarCarComponent()}</React.Fragment>
                                    )}
                                    {((isLoading || isLoading === null) || isSimilarCarLoading) && Array(...new Array(NUMBER.NINE)).map((i, index) => {
                                        return <div styleName={"styles.marginTop24"} key={index} className={"col-md-4"}><Skeleton /></div>;
                                    })}
                                </div>

                                {(totalCars + totalSimilarCars === NUMBER.ZERO && !isLoading && isSimilarCarLoading === false && content.length === 0) &&
                                    <NoCarFoundRevamp handleViewCars={handleViewCars} />
                                }

                            </InfiniteScroll>
                            <TrackImpression event={{ amplitudeName: AMPLITUDE_EVENTS_CATEGORY.HAPPY_PURCHASES_SEEN }} wrapWithDiv={false}>
                                <div styleName={"styles.testimonialWrapper"}>
                                    <HappyPurchase source={PAGE_SOURCE.CLP} />
                                </div>
                            </TrackImpression>
                            <div styleName={"styles.googleRatingWrapper"}>
                                <HappyBuyerReviewCard rating={google?.rating} number={`${google?.reviews} reviews`} productIcon={Google} reviewLink={CDP_REVIEW_LINK.google_review}  />
                                <HappyBuyerReviewCard rating={trustPilot?.rating} number={`${trustPilot?.reviews} reviews`} productIcon={TrustPilot} reviewLink={CDP_REVIEW_LINK.trust_pilot}  />
                                <HappyBuyerReviewCard rating={productReview?.rating} number={`${productReview?.reviews} reviews`} productIcon={Product} reviewLink={CDP_REVIEW_LINK.product_review} />
                            </div>
                        </div>
                    </div>
                    {
                        showLocationModal && <OurLocationModal handleModalClose={handleShowLocationCallback}/>
                    }
                    {/* <div className={"row"}>
                        {content.length <= NUMBER.TWENTY && Object.keys(SEO_FILTER_CAR_LIST).map(item => Number(item) < content.length ? null : renderSeoFilterComponent(item))}
                    </div> */}
                </div>
            </div>
        </React.Fragment>
    );
};

CarListRevamp.propTypes = {
    content: PropTypes.array,
    totalCars: PropTypes.number,
    page: PropTypes.number,
    isLoading: PropTypes.bool,
    fetchCarListConnect: PropTypes.func,
    getDrivaPreApprovalLoanDetailsConnect: PropTypes.func,
    config: PropTypes.object,
    allFilters: PropTypes.object,
    location: PropTypes.object,
    isSSR: PropTypes.bool,
    updateSSRStatusConnect: PropTypes.func,
    getInhouseEligibilityConnect: PropTypes.func,
    selectedCityCode: PropTypes.number,
    urlOptions: PropTypes.object,
    selectedFilters: PropTypes.array,
    appliedSuggestions: PropTypes.array,
    shouldReloadList: PropTypes.bool,
    reloadCarListConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    fetchWishlistedCarsListConnect: PropTypes.func,
    personalised: PropTypes.bool,
    ipDetectedState: PropTypes.string,
    inHouseFinanceEligibility: PropTypes.bool,
    preApproved: PropTypes.bool,
    userTradeInData: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    quotesAvailable: PropTypes.bool,
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    selectedOnScreenFilter: PropTypes.string,
    loanType: PropTypes.object,
    setMarketingCategoryConnect: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    fbEventType: PropTypes.string,
    metaContent: PropTypes.object,
    isSortModalOpen: PropTypes.bool,
    updateAllFiltersVisibilityConnect: PropTypes.func,
    updateSortModalVisibilityConnect: PropTypes.func,
    selectedSort: PropTypes.obect,
    dynamicContent: PropTypes.object,
    selectedCity: PropTypes.object,
    selectedCategory: PropTypes.object,
    categories: PropTypes.object,
    showFilterPageRevamp: PropTypes.bool,
    similarCarsContent: PropTypes.array,
    inlineFilters: PropTypes.array,
    totalSimilarCars: PropTypes.number,
    buyWithConfidence: PropTypes.array,
    absolutePermissibleLoanAmount: PropTypes.number,
    maxPermissibleRepaymentPerWeek: PropTypes.number,
    stEligible: PropTypes.bool,
    userGeoData: PropTypes.object,
    similarCarPage: PropTypes.number,
    totalSimilarPages: PropTypes.number,
    isSimilarCarLoading: PropTypes.bool,
    fetchSimilarCarConnect: PropTypes.func,
    closeClpNudgeHandlerConnect: PropTypes.func,
    saleConfig: PropTypes.object,
    webPriceDropDesktop: PropTypes.object,
    galleryOnTheFlyDesktop: PropTypes.object,
    testDriveConfig: PropTypes.object,
    ratingAndReviews: PropTypes.object
};

CarListRevamp.defaultProps = {
    ratingAndReviews: {
        google: { rating: 4.6, reviews: "1000+"},
        trustPilot: { rating: 4.5, reviews: "300+"},
        productReview: { rating: 4.5, reviews: "650+" }
    }
};

export default withWishlist(withLogin(CarListRevamp));
